var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-1 nested-menu-tab-button-container"},[_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('registration_status'),"icon":"icon-list","route":"dashboard.registration_status"}}),_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('announcements'),"icon":"icon-mic","route":"dashboard.announcements"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }